// geometry.js

// Convex hull (Andrew monotone chain)
export function convexHull(points) {
  if (!points || points.length <= 2) return points ? points.slice() : [];
  const pts = points.slice().sort((a,b)=> (a.x-b.x)|| (a.y-b.y));
  const cross = (o,a,b)=>(a.x-o.x)*(b.y-o.y)-(a.y-o.y)*(b.x-o.x);
  const lower=[];
  for(const p of pts){
    while(lower.length>=2 && cross(lower[lower.length-2], lower[lower.length-1], p)<=0) lower.pop();
    lower.push(p);
  }
  const upper=[];
  for(let i=pts.length-1;i>=0;i--){
    const p=pts[i];
    while(upper.length>=2 && cross(upper[upper.length-2], upper[upper.length-1], p)<=0) upper.pop();
    upper.push(p);
  }
  upper.pop(); lower.pop();
  return lower.concat(upper);
}

export function polyToPoints(poly){
  const pts=[];
  for(let i=0;i<poly.length;i+=2) pts.push({x:poly[i], y:poly[i+1]});
  return pts;
}
export function pointsToPolyArray(pts){
  const arr=[];
  for(const p of pts){ arr.push(p.x, p.y); }
  return arr;
}

export function pointInPoly(x, y, poly) {
  let inside = false;
  for (let i=0, j=poly.length-2; i<poly.length; j=i, i+=2) {
    const xi = poly[i], yi = poly[i+1];
    const xj = poly[j], yj = poly[j+1];
    const intersect = ((yi > y) !== (yj > y)) && (x < (xj - xi) * (y - yi) / ((yj - yi) || 1e-12) + xi);
    if (intersect) inside = !inside;
  }
  return inside;
}

export function polyAreaAbs(poly) {
  let a = 0;
  for (let i = 0, j = poly.length - 2; i < poly.length; j = i, i += 2) {
    a += (poly[j] * poly[i + 1]) - (poly[i] * poly[j + 1]);
  }
  return Math.abs(a) * 0.5;
}

export function polyBounds(poly) {
  let minx=Infinity, miny=Infinity, maxx=-Infinity, maxy=-Infinity;
  for (let i=0;i<poly.length;i+=2) {
    const x=poly[i], y=poly[i+1];
    if (x<minx) minx=x; if (y<miny) miny=y;
    if (x>maxx) maxx=x; if (y>maxy) maxy=y;
  }
  return { minx, miny, maxx, maxy };
}

export function overlayBounds(ov) {
  let minx=Infinity, miny=Infinity, maxx=-Infinity, maxy=-Infinity;
  for (const poly of ov.polys) {
    const b = polyBounds(poly);
    if (b.minx < minx) minx = b.minx;
    if (b.miny < miny) miny = b.miny;
    if (b.maxx > maxx) maxx = b.maxx;
    if (b.maxy > maxy) maxy = b.maxy;
  }
  return { minx, miny, maxx, maxy };
}
